import React from 'react';
import Emergency from '../components/Emergency';
import { Phone, Clock, AlertCircle, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { businessInfo } from '../data/mock';

const EmergencyPage = () => {
  const emergencyServices = [
    {
      title: "Broken Spring Repair",
      description: "Immediate spring replacement to get your door working safely again"
    },
    {
      title: "Door Off Track",
      description: "Fast track realignment and repair to restore proper operation"
    },
    {
      title: "Opener Malfunction",
      description: "Quick diagnosis and repair of all garage door opener issues"
    },
    {
      title: "Broken Cable",
      description: "Emergency cable replacement for safe door operation"
    },
    {
      title: "Door Won't Close",
      description: "Rapid troubleshooting and repair to secure your garage"
    },
    {
      title: "Storm Damage",
      description: "Emergency repairs for weather-damaged garage doors"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-green-50">
      {/* Hero */}
      <section className="pt-32 pb-12 bg-gradient-to-r from-red-600 to-red-700">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center text-white">
            <AlertCircle size={80} className="mx-auto mb-6 animate-pulse" />
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              24/7 Emergency Service
            </h1>
            <p className="text-2xl text-red-100 mb-8">
              Garage Door Emergency? We're Here to Help!
            </p>
            <Button 
              onClick={() => window.location.href = `tel:${businessInfo.phone}`}
              size="lg"
              className="bg-white text-red-700 hover:bg-gray-100 font-bold px-12 py-8 text-2xl shadow-2xl"
            >
              <Phone size={32} className="mr-3" />
              CALL NOW: {businessInfo.phone}
            </Button>
          </div>
        </div>
      </section>

      {/* Why Choose Us for Emergencies */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Fast Emergency Response</h2>
            <p className="text-xl text-gray-600">When you need us most, we're there within 1-2 hours</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mb-16">
            <Card className="border-2 border-green-200 text-center">
              <CardHeader>
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Clock size={32} className="text-green-700" />
                </div>
                <CardTitle className="text-2xl">1-2 Hour Response</CardTitle>
                <CardDescription className="text-base">
                  We arrive quickly to handle your emergency
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="border-2 border-blue-200 text-center">
              <CardHeader>
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Phone size={32} className="text-blue-700" />
                </div>
                <CardTitle className="text-2xl">Available 24/7</CardTitle>
                <CardDescription className="text-base">
                  Day or night, weekends and holidays - we're here
                </CardDescription>
              </CardHeader>
            </Card>

            <Card className="border-2 border-purple-200 text-center">
              <CardHeader>
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <CheckCircle size={32} className="text-purple-700" />
                </div>
                <CardTitle className="text-2xl">Expert Technicians</CardTitle>
                <CardDescription className="text-base">
                  Experienced professionals with all necessary parts
                </CardDescription>
              </CardHeader>
            </Card>
          </div>
        </div>
      </section>

      {/* Common Emergency Services */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Common Emergency Repairs</h2>
            <p className="text-xl text-gray-600">We handle all types of garage door emergencies</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {emergencyServices.map((service, idx) => (
              <Card key={idx} className="border-2 hover:border-red-500 hover:shadow-xl transition-all">
                <CardHeader>
                  <CardTitle className="text-lg text-red-700">{service.title}</CardTitle>
                  <CardDescription>{service.description}</CardDescription>
                </CardHeader>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Emergency Component */}
      <Emergency />

      {/* Bottom CTA */}
      <section className="py-20 bg-gradient-to-r from-red-600 to-red-700 text-white text-center">
        <div className="container mx-auto px-4">
          <AlertCircle size={64} className="mx-auto mb-6" />
          <h2 className="text-4xl font-bold mb-6">Don't Wait - Call Now!</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Every minute counts in an emergency. Our team is standing by to help you.
          </p>
          <Button 
            onClick={() => window.location.href = `tel:${businessInfo.phone}`}
            size="lg"
            className="bg-white text-red-700 hover:bg-gray-100 font-bold px-12 py-8 text-xl"
          >
            <Phone size={28} className="mr-3" />
            {businessInfo.phone}
          </Button>
        </div>
      </section>
    </div>
  );
};

export default EmergencyPage;